import { Button as ChakraButton } from '@chakra-ui/react';
import React from 'react';

function ButtonComponent({ children, ...props }, ref) {
  return (
    <ChakraButton
      bgColor="#FFA200"
      fontSize="15px"
      color="white"
      borderRadius={0}
      _hover={{
        filter: 'brightness(0.9)'
      }}
      _active={{
        filter: 'brightness(1.1)'
      }}
      ref={ref}
      {...props}>
      {children}
    </ChakraButton>
  );
}

export const Button = React.forwardRef(ButtonComponent);
